// extracted by mini-css-extract-plugin
export var jumbotronBackground = "_2019-module--jumbotronBackground--5AuZU";
export var hackawayLogoClass = "_2019-module--hackawayLogoClass--KQZv6";